'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { StickyHeader } from './StickyHeader'

interface StickyHeaderBlokProps {
  blok: {
    CTATitle?: string
    CTALink?: any
    hubspotFormGuid?: string
    mobileTitle?: string
  } & SbBlokData
}

const PhnxStickyHeader: FC<StickyHeaderBlokProps> = ({ blok }) => {
  const ctaLink = blok?.CTALink?.cached_url
    ? {
        story: {
          fullSlug: blok.CTALink.cached_url,
        },
      }
    : undefined

  return (
    <div {...storyblokEditable(blok)}>
      <StickyHeader
        ctaText={blok?.CTATitle || undefined}
        ctaLink={ctaLink}
        mobileTitle={blok?.mobileTitle || undefined}
        hubspotID={blok?.hubspotFormGuid || undefined}
      />
    </div>
  )
}

export default PhnxStickyHeader
